import { useEffect, useState } from "react";

export function useImageScale(containerRef, naturalSize, hovered) {
  const [containerSize, setContainerSize] = useState({ w: 0, h: 0 });

  useEffect(() => {
    if (!containerRef?.current) return;
    const resizeObs = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;
        setContainerSize({ w: width, h: height });
      }
    });
    resizeObs.observe(containerRef.current);
    return () => resizeObs.disconnect();
  }, [containerRef]);

  const isLandscape = naturalSize.w > naturalSize.h;

  let scale = 1;
  if (naturalSize.w && naturalSize.h && containerSize.w && containerSize.h) {
    const scaleX = containerSize.w / naturalSize.w;
    const scaleY = containerSize.h / naturalSize.h;
    scale = hovered ? Math.min(scaleX, scaleY) : isLandscape ? scaleY : scaleX;
  }
  //console.log("scale",scale);
  return scale;
}
